import { FC } from 'react';
import { SeoLinkType } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';

type PropsType = {
  link: SeoLinkType;
};

const SeoBlockLink: FC<PropsType> = ({
  link,
}) => (
  <Button
    pill
    navLinkProps={{
      to: link.link.to,
      state: link.link.state,
      variant: ({ isActive }) => {
        if (isActive) {
          return ButtonVariant.white;
        }
        return ButtonVariant.outlineWhite;
      },
    }}
    dataAttributeList={{
      ...link.link.state.routerConfig,
    }}
  >
    {link.title}
  </Button>
);

export { SeoBlockLink };
